module.exports = __webpack_public_path__ + "img/filter-icon.4f8df6f5.svg";